import queryString from 'query-string';

import { AUTH_LOGGED_IN_PARAMETER, AUTH_ROUTES, TYPO3_URL } from '../config';
import { getLanguage } from './localization';

export const isPageProtected = () => {
  const protectedUrlPatterns = ['/shop/checkout'];
  const patternIdx = protectedUrlPatterns.findIndex((urlPattern) =>
    window.location.href.includes(urlPattern)
  );
  return patternIdx >= 0;
};

export const getLoginUrl = (returnTo) =>
  queryString.stringifyUrl({
    url: AUTH_ROUTES.LOGIN,
    query: {
      returnTo:
        returnTo ||
        queryString.stringifyUrl({
          url: window.location.href,
          query: {
            [AUTH_LOGGED_IN_PARAMETER]: true,
          },
        }),
      lang: getLanguage(),
    },
  });

export const getSignUpUrl = (returnTo) =>
  queryString.stringifyUrl({
    url: AUTH_ROUTES.SIGNUP,
    query: {
      returnTo:
        returnTo ||
        queryString.stringifyUrl({
          url: window.location.href,
          query: {
            [AUTH_LOGGED_IN_PARAMETER]: true,
          },
        }),
      lang: getLanguage(),
    },
  });

export const getLogOutUrl = () =>
  queryString.stringifyUrl({
    url: AUTH_ROUTES.LOGOUT,
    query: {
      returnTo: isPageProtected()
        ? `${TYPO3_URL}/${getLanguage()}`
        : window.location.href,
    },
  });
